/** How the office writes an assignment's or a visit's number: A-1001, V-10001. Blank before it has one. */
export const assignmentRef = (n?: number | null) => (n ? `A-${n}` : '');
export const visitRef = (n?: number | null) => (n ? `V-${n}` : '');
